import { Injectable } from '@angular/core';
import { UserInfoEngine } from '@memberjunction/core-entities';
import { AD_FEATURE_INDEX_SETTING, type AGUAdRotationStore } from 'agu_app_shell';

/**
 * The Home feature's rotation index (`AD_FEATURE_INDEX_SETTING`) as a `MJ: User Settings` row through `UserInfoEngine` — the
 * pattern of the OEP tour (feedbackplatform/overlays/oep-tour.component.ts): `Config(false)` then `GetSetting`, written with
 * `SetSettingDebounced`. `AGUAdSessionService` treats any failure here as index 0.
 */
@Injectable()
export class RaAdRotationStore implements AGUAdRotationStore {
    async Load(): Promise<string | undefined> {
        await UserInfoEngine.Instance.Config(false);
        return UserInfoEngine.Instance.GetSetting(AD_FEATURE_INDEX_SETTING);
    }

    Save(value: string): void {
        UserInfoEngine.Instance.SetSettingDebounced(AD_FEATURE_INDEX_SETTING, value);
    }
}
